export class Queue<T> {
  elements: Record<number, T> = {}
  head = 0
  tail = 0

  get length() {
    return this.tail - this.head
  }

  get isEmpty() {
    return this.length === 0
  }

  enqueue = (element: T) => {
    this.elements[this.tail++] = element
  }

  dequeue = () => {
    const item = this.elements[this.head]
    delete this.elements[this.head++]
    return item
  }

  replaceLast = (element: T) => {
    if (this.isEmpty) {
      // If queue is empty, just add the element
      this.enqueue(element)
    } else {
      // Otherwise, replace the last item at the tail-1 index
      this.elements[this.tail - 1] = element
    }
  }

  peek() {
    return this.elements[this.head]
  }
}